import type { GetCategoryTreeResponse } from 'cf-grpc/creativefabrica/content/v2/service_pb'

import { MenuItem } from './menu-item'
import { useMenu } from './context'

interface DropdownProps {
  menuItems: GetCategoryTreeResponse
  showAll: string
  categoryPath: string
  linkPrefix?: string
}

export function Dropdown({ menuItems, showAll, categoryPath, linkPrefix }: DropdownProps) {
  const { allOpen, setAllOpen, mobileOpen } = useMenu()

  return (
    <>
      {mobileOpen ? (
        // oxlint-disable-next-line react/button-has-type
        <button
          className="text-12 mb-4 mt-6 uppercase outline-none md:hidden"
          onClick={() => setAllOpen(open => !open)}
          aria-expanded={allOpen ? 'true' : 'false'}
          data-state={allOpen ? 'open' : 'closed'}
          data-testid="show-all-mobile"
        >
          {showAll} <span className="inline-block w-1">{allOpen ? '-' : '+'}</span>
        </button>
      ) : null}
      {menuItems.subCategories.map(item => (
        <MenuItem
          key={item.slug}
          category={item}
          categoryPath={categoryPath}
          linkPrefix={linkPrefix}
        />
      ))}
    </>
  )
}
